import Select from "react-select";
const PerPageSelect = ({ value, onChange, options = [10,20,50,100,150,200] }) => {
  const selectOptions = options.map((item) => ({
    value: item,
    label: `${item} / Records`,
  }));
  const selectedOption = selectOptions.find((opt) => opt.value === value);
  return (
    <div style={{ width: 140 }}>
      <Select
        value={selectedOption}
        onChange={(selected) => onChange(selected.value)}
        options={selectOptions}
        isSearchable={false}
        styles={{
          control: (base) => ({
            ...base,
            minHeight: "36px",
            height: "36px",
            fontSize: "14px",
          }),
          dropdownIndicator: (base) => ({
            ...base,
            padding: 4,
          }),
          valueContainer: (base) => ({
            ...base,
            padding: "0 8px",
          }),
        }}
      />
    </div>
  );
};

export default PerPageSelect;
